import TYPES from '../actions/types';

const INITIAL_STATE = {
  id: 0,
  name: '',
  dateSend: '',

  loadingPostForm: false,
  postDataError: { message: '', errors: [] },
}

export default function(state = INITIAL_STATE, action) {
  switch(action.type) {
    case TYPES.loadingDataFormCancel:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        dateSend: action.payload.dateSend,
      }

    case TYPES.loadFormCancel:
      return { ...state, loadingPostForm: !state.loadingPostForm };

    case TYPES.formCancelError:
      return { ...state, postDataError: action.payload.data };

    default:
      return state;
  }
}
